import { render } from "./ReturningCustomerRateChart.vue?vue&type=template&id=2b80bd54&ts=true"
import script from "./ReturningCustomerRateChart.vue?vue&type=script&lang=ts"
export * from "./ReturningCustomerRateChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__